export const ERROR_MSGS = {
	EN: {
		NETWORK_CONNECTIVITY: 'No network connection found. Kindly check your internet connection',
		NETWORK_CONNECTIVITY_STATUS: 599,
		NETWORK_CONNECTIVITY_DESCRIPTION: 'Network connection timeout error',
		//Error Screen
		ERROR_TITLE: 'Error',
		ERROR_SUBTITLE: 'Oops',
		BACK_BTN_TEXT: 'Go back',
		NOT_FOUND: 'Not Found',
		BAD_REQUEST: 'Bad Request.',
		UNAUTHORIZED_ACCESS: 'Unauthorized Access.',
		INTERNAL_SERVER_ERROR: 'Internal Server Error.',
		ACCESS_FORBIDDEN: 'Access Forbidden.',
		SERVICE_UNAVAILABLE: 'Service Unavailable.',
		NETWORK_ERROR: 'No network connection found. Kindly check your internet connection',
		GENERAL_ERROR: 'Something went wrong',
		INVALID_STORE:
			'Unable to load store configuration or invalid store found. <br/> Try again later.',
		INVALID_PRODUCT: 'Product Item not found or might become unavailable.',
	},
	UR: {
		NETWORK_CONNECTIVITY: 'کوئی نیٹ ورک کنکشن نہیں ملا۔ برائے مہربانی اپنا انٹرنیٹ کنکشن چیک کریں',
		NETWORK_CONNECTIVITY_STATUS: 599,
		NETWORK_CONNECTIVITY_DESCRIPTION: 'نیٹ ورک کنکشن ٹائم آؤٹ خرابی',
		//Error Screen
		ERROR_TITLE: 'غلطی',
		ERROR_SUBTITLE: 'غلطی ہوگئی',
		BACK_BTN_TEXT: 'واپس جائيں',
		NOT_FOUND: 'نہيں ملا',
		BAD_REQUEST: 'غلط درخواست۔',
		UNAUTHORIZED_ACCESS: 'غیرمجاز رسائی۔',
		INTERNAL_SERVER_ERROR: 'اندرونی سرور کی غلطی۔',
		ACCESS_FORBIDDEN: 'رسائی ممنوع۔',
		SERVICE_UNAVAILABLE: 'سہولت دستیاب نہيں۔',
		NETWORK_ERROR: 'کوئی نیٹ ورک کنکشن نہیں ملا۔ برائے مہربانی اپنا انٹرنیٹ کنکشن چیک کریں',
		GENERAL_ERROR: 'کچھ غلط ہو گیا',
		INVALID_STORE:
			'اسٹور کنفیگریشن لوڈ کرنے سے قاصر یا غلط اسٹور ملا۔<br/>  بعد میں دوبارہ کوشش کریں۔',
		INVALID_PRODUCT: 'پروڈکٹ آئٹم نہیں ملا یا ہوسکتا ہے کہ وہ دستیاب نہ ہو۔',
	},
}
